import { PromiseFactory } from '../misc/PromiseFactory';
import moment from 'moment';
export var TenantRoles;
(function (TenantRoles) {
    TenantRoles["Guest"] = "guest";
    TenantRoles["Member"] = "member";
    TenantRoles["Admin"] = "admin";
})(TenantRoles || (TenantRoles = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["PendingTenant"] = "PendingTenant";
    UserStatus["PendingUser"] = "PendingUser";
    UserStatus["Accepted"] = "Accepted";
    UserStatus["Rejected"] = "Rejected";
})(UserStatus || (UserStatus = {}));
export class TenantService {
    static $inject = ['DEFAULT_PORTAL_URL', 'BlipService', 'BLIP_DOMAIN', 'BLIP_DOMAIN_URL', 'PORTALDOMAIN', 'MESSAGINGHUBDOMAIN', 'AccountService2', 'UrlTenantHandlerService'];
    constructor(DEFAULT_PORTAL_URL, BlipService, BLIP_DOMAIN, BLIP_DOMAIN_URL, PORTALDOMAIN, MESSAGINGHUBDOMAIN, AccountService2, UrlTenantHandlerService) {
        this.DEFAULT_PORTAL_URL = DEFAULT_PORTAL_URL;
        this.BlipService = BlipService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
        this.PORTALDOMAIN = PORTALDOMAIN;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.AccountService2 = AccountService2;
        this.UrlTenantHandlerService = UrlTenantHandlerService;
        this.ERROR_CODE_NOT_FOUND = 67;
        this.STATUS_SUCESS = 'success';
        this.FORMAT_DATE = 'DD/MM/YYYY HH:mm:ss';
        this.guest = 'guest';
        this.existingTenant = async (tenant) => {
            try {
                const existingTenant = await this.getIfExists(tenant);
                return existingTenant;
            }
            catch (e) {
                return undefined;
            }
        };
    }
    /**
     * Add or update a tenant
     * @param tenant
     */
    async set(tenant) {
        await this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            type: 'application/vnd.iris.portal.tenant+json',
            uri: `/tenants/${tenant.id}`,
            resource: tenant,
        });
    }
    async setTenantNew(tenant) {
        await this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            type: 'application/vnd.iris.portal.tenant+json',
            uri: '/tenant/create',
            resource: tenant,
        });
    }
    /**
     * Get tenant by Id or all tenants
     * @param tenant
     */
    get(id) {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants${id ? `/${id}` : ''}`,
        });
    }
    /**
     * Get all tenant's bots
     */
    getBotsByTenantId() {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${this.getTenantPrefixFromUrl()}/applications`,
        });
    }
    /**
     * Get personal tenant
     */
    async getPersonalTenant() {
        const user = await this.AccountService2.me();
        return {
            id: '',
            name: user.fullName,
        };
    }
    getIfExists(id) {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/existing-tenant${id ? `/${id}` : ''}`,
        });
    }
    /**
     * Get a valid id for email and company name
     * @param email user email
     * @param name tenant name
     */
    getValidId(email, name) {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenant-valid-id?email=${email}${name ? `&name=${encodeURIComponent(name)}` : ''}`,
        });
    }
    getPermissionCreateContract() {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: '/tenant-create-permission',
        });
    }
    /**
     * Get logged user tenants
     */
    mine() {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: '/tenants-mine',
        });
    }
    /**
     * Get logged user tenant users
     */
    tenantUsersMine() {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: '/tenant-users-mine',
        });
    }
    /**
     * Get all tenant members
     * @param tenantId Get All tenant user
     */
    async getTenantUsers(tenantId) {
        await this.BlipService.waitForInitialization();
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/users`,
        });
    }
    async getTenantClusterName(applicationName) {
        await this.BlipService.waitForInitialization();
        const tenantInfo = await this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/applications/${applicationName}@${this.MESSAGINGHUBDOMAIN}/tenant`,
        });
        return tenantInfo && tenantInfo.clusterName || '';
    }
    async getApplicationTenant(applicationName) {
        await this.BlipService.waitForInitialization();
        const result = await this.BlipService.processCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/applications/${applicationName}@${this.MESSAGINGHUBDOMAIN}/tenant`,
        });
        const applicationTenant = result.resource.id;
        return applicationTenant || '';
    }
    async getTenantClusterNameByTenantId(tenantId) {
        await this.BlipService.waitForInitialization();
        const tenantCluster = await this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/cluster`,
        });
        return tenantCluster;
    }
    async getInvalidApplicationsToLinkTenant(applicationsIdentity, tenantId) {
        const query = applicationsIdentity.map(i => `${i}@msging.net`).join(',');
        const { items } = await this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/validate-applications?applications=${query}`,
        });
        return items.map(i => i.replace('@msging.net', ''));
    }
    /**
     * Join a tenant
     * @param tenantId
     * @param userIdentity
     */
    async joinTenant(tenantId) {
        const loggedUser = await this.AccountService2.me();
        return this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/users`,
            type: 'application/vnd.iris.portal.tenant-user+json',
            resource: {
                tenantId,
                userIdentity: `${encodeURIComponent(loggedUser.email)}@${this.BLIP_DOMAIN}`,
            },
        });
    }
    inviteMany(emails, tenantId, role) {
        const items = emails.map(email => ({
            tenantId,
            userIdentity: `${encodeURIComponent(email)}@${this.BLIP_DOMAIN}`,
            roleId: role,
        }));
        return this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/users`,
            type: 'application/vnd.lime.collection+json',
            resource: {
                items,
                itemType: 'application/vnd.iris.portal.tenant-user+json',
                total: items.length,
            },
        });
    }
    setMemberStatus(tenantId, userIdentity, status) {
        return this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/users/${encodeURIComponent(userIdentity)}/user-status`,
            type: 'application/vnd.iris.portal.tenant-user-status',
            resource: status,
        });
    }
    /**
     * Get a tenant user
     * @param tenantId
     * @param userIdentity
     */
    getTenantUser(tenantId, userIdentity) {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/users/${encodeURIComponent(userIdentity)}`,
        });
    }
    getTenantUserDefaultContract() {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: '/tenants-default-contract',
        });
    }
    setTenantUserDefaultContract(tenant) {
        return this.BlipService.processCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenant.id}/default-contract`,
            type: 'application/vnd.iris.portal.tenant+json',
            resource: tenant,
        });
    }
    /**
     * @param userIdentity
     * @param tenantId
     * @param requiredRoleId
     */
    async hasRequiredTenantRole(userIdentity, tenantId, requiredRoleIds) {
        try {
            const tenantUser = await this.getTenantUser(tenantId, userIdentity);
            return requiredRoleIds.includes(tenantUser.roleId);
        }
        catch (e) {
            console.error('Could not get tenant user role');
            return false;
        }
    }
    /**
     * @param userIdentity
     * @param tenantId
     * @param requiredRoleId
     */
    async currentUserHasRequiredTenantRole(tenantId, requiredRoleIds) {
        const user = await this.AccountService2.me();
        try {
            const tenantUser = await this.getTenantUser(tenantId, user.identity);
            return requiredRoleIds.includes(tenantUser.roleId);
        }
        catch (e) {
            console.error('Could not get tenant user role');
            return false;
        }
    }
    assignBotToTenant(botShortName, tenantId) {
        return this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/applications`,
            type: 'application/vnd.lime.identity',
            resource: `${botShortName}@${this.MESSAGINGHUBDOMAIN}`,
        });
    }
    async assignMultipleBotsToTenant(applicationsIdentity, tenantId, contractAdminCanMigrateBots) {
        const uri = contractAdminCanMigrateBots ? `/tenants/${tenantId}/applications-contract-admin` : `/tenants/${tenantId}/applications`;
        const commandResponse = await this.BlipService.processCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri,
            type: 'application/vnd.lime.collection+json',
            resource: {
                itemType: 'application/vnd.lime.identity',
                total: applicationsIdentity.length,
                items: applicationsIdentity.map(i => `${i}@${this.MESSAGINGHUBDOMAIN}`),
            },
        });
        return this.BlipService.ensureCommandSuccess(commandResponse);
    }
    getTenantUrl(tenantId, withProtocol = true) {
        const protocol = this.getProtocol();
        if (tenantId) {
            return `${withProtocol ? protocol : ''}${tenantId}.${this.PORTALDOMAIN}`;
        }
        else {
            const domainUrl = this.BLIP_DOMAIN_URL.slice(0, -1);
            return withProtocol ? domainUrl : domainUrl.replace(protocol, '');
        }
    }
    getDefaultPortalUrl(withProtocol = true) {
        const protocol = this.getProtocol();
        const defaultUrl = this.DEFAULT_PORTAL_URL.slice(0, -1);
        return withProtocol ? defaultUrl : defaultUrl.replace(protocol, '');
    }
    getProtocol() {
        return this.PORTALDOMAIN.includes('localhost') ? 'http://' : 'https://';
    }
    setGrantExternalLoginAccess(tenantId, userToken) {
        return this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/tenant-user-external-login`,
            type: 'text/plain',
            resource: userToken,
        });
    }
    async CreatePersonalTenant() {
        const personalAccount = await this.AccountService2.me();
        const { id, name } = await this.getValidId(personalAccount.email, personalAccount.fullName);
        const tenantUrl = this.getTenantUrl(id);
        const tenant = {
            id: id,
            name: name,
        };
        await this.set(tenant);
        await this.setTenantUserDefaultContract(tenant);
        return tenantUrl;
    }
    /**
     * Choose which tenant screen user will be redirected
     */
    async TryGetDomainTenant() {
        try {
            const user = await this.AccountService2.me();
            const emailDomain = this.AccountService2.getEmailDomain(user.email);
            const domainTenant = await this.getIfExists(emailDomain);
            return domainTenant;
        }
        catch (e) {
            return undefined;
        }
    }
    addTenantPrefixToUrl(URL, tenantId = undefined, defaultUrl = undefined) {
        return this.UrlTenantHandlerService.addTenantPrefixToUrl(URL, tenantId, defaultUrl);
    }
    getTenantPrefixFromUrl() {
        return this.UrlTenantHandlerService.getTenantPrefixFromUrl();
    }
    async checkIfBillableContract() {
        const tenantId = await this.getTenantPrefixFromUrl();
        if (tenantId) {
            return await this.isBillablePlan(tenantId);
        }
        else {
            return false;
        }
    }
    async isContractAdmin(identity) {
        const tenantId = await this.getTenantPrefixFromUrl();
        try {
            const tenantUser = await this.getTenantUser(tenantId, identity);
            return (tenantUser.roleId == TenantRoles.Admin);
        }
        catch (error) {
            return false;
        }
    }
    async isContractRoleAuthorized(identity, authorizedRoles) {
        const tenantId = await this.getTenantPrefixFromUrl();
        try {
            const tenantUser = await this.getTenantUser(tenantId, identity);
            const exists = authorizedRoles.some(v => (v === tenantUser.roleId));
            return exists;
        }
        catch (error) {
            return false;
        }
    }
    async isEmailOnTenant(userIdentity) {
        const tenantId = this.getTenantPrefixFromUrl();
        try {
            const tenantUser = await this.getTenantUser(tenantId, userIdentity);
            return (tenantUser != undefined);
        }
        catch {
            return false;
        }
    }
    async isBillablePlan(tenant) {
        const metrics = await this.getMetrics(tenant);
        return metrics?.items.some(m => m.metricId === 'Agent');
    }
    async getMetrics(tenant) {
        try {
            const metrics = await this.BlipService.sendCommand({
                method: 'get',
                to: `postmaster@billing.${this.BLIP_DOMAIN}`,
                uri: `/tenants/${tenant}/subscription/plan/metrics`,
            });
            return metrics;
        }
        catch (err) {
            return undefined;
        }
    }
    async getTenantPlanAndCluster(tenantId) {
        const plan = tenantId ?
            await this.AccountService2.getTenantPlan(tenantId) :
            await this.AccountService2.getAccountPlan();
        let planName = plan && plan.name && plan.name.toLowerCase() || 'standard';
        if (planName == 'partner') {
            planName = 'business';
        }
        let clusterName = undefined;
        if (plan.extras) {
            clusterName = plan.extras.Cluster;
        }
        return { planName, clusterName };
    }
    async getTenantPlan(tenantId) {
        const { planName } = await this.getTenantPlanAndCluster(tenantId);
        return planName;
    }
    async isOrganizationEnabled() {
        if (this.isOrganizationGettingPromise === undefined) {
            this.isOrganizationGettingPromise = PromiseFactory.new({});
            this.isOrganization = await this.getOrganizationEnabled();
            this.isOrganizationGettingPromise.resolve();
            return this.isOrganization;
        }
        else {
            await this.isOrganizationGettingPromise.promise;
            return this.isOrganization;
        }
    }
    async getOrganizationEnabled() {
        try {
            await this.BlipService.waitForInitialization();
            const tenants = await this.tenantUsersMine();
            return tenants?.items.length > 0;
        }
        catch (err) {
            const error = JSON.parse(err);
            if (error.reason.code !== this.ERROR_CODE_NOT_FOUND) {
                console.error(err);
            }
            return false;
        }
    }
    async saveAgents(emails, tenantId) {
        const items = emails.map(email => ({
            tenantId,
            userIdentity: `${encodeURIComponent(email)}@${this.BLIP_DOMAIN}`,
        }));
        return this.BlipService.sendCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/agents`,
            type: 'application/vnd.lime.collection+json',
            resource: {
                items,
                itemType: 'application/vnd.iris.portal.tenant-agent-user+json',
                total: items.length,
            },
        });
    }
    async getMigrationEstimatedDate(numberBotsToMigrate, formatDate = this.FORMAT_DATE) {
        const response = await this.BlipService.processCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/queue-migration-estimated-date/bots/${numberBotsToMigrate}`,
        });
        if (response.status !== this.STATUS_SUCESS || !this.isValidDate(response.resource)) {
            console.error(response);
            return undefined;
        }
        return moment(new Date(response.resource)).format(formatDate);
    }
    isValidDate(object) {
        const timestamp = Date.parse(object);
        return !isNaN(timestamp);
    }
    async addToQueueMigrationBots(applicationsIdentity, tenantIdOrigin, tenantIdDestination) {
        const uri = tenantIdOrigin ? `/queue-migration/tenants/${tenantIdDestination}/queue?originTenantId=${tenantIdOrigin}` :
            `/queue-migration/tenants/${tenantIdDestination}/queue`;
        const commandResponse = await this.BlipService.processCommand({
            method: 'set',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri,
            type: 'application/vnd.lime.collection+json',
            resource: {
                items: applicationsIdentity.map(i => `${i}@${this.MESSAGINGHUBDOMAIN}`),
                itemType: 'application/vnd.lime.identity',
                total: applicationsIdentity.length,
            },
        });
        const { resource } = this.BlipService.ensureCommandSuccess(commandResponse);
        this.groupIdMigration = resource;
        return resource;
    }
    async getTotalMembersApplications(application) {
        const response = await this.BlipService.processCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/applications/${application}@${this.MESSAGINGHUBDOMAIN}/users/accounts/total`,
        });
        return response.resource.total;
    }
    async saveCallsTerms(tenantId, termsUrl, userIdentity) {
        return await this.BlipService.processCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'set',
            uri: `/tenants/${tenantId}/calls-terms`,
            type: 'application/json',
            resource: {
                'termsUrl': termsUrl,
                'userIdentity': userIdentity,
            },
        });
    }
}
TenantService.$inject = ['DEFAULT_PORTAL_URL', 'BlipService', 'BLIP_DOMAIN', 'BLIP_DOMAIN_URL', 'PORTALDOMAIN', 'MESSAGINGHUBDOMAIN', 'AccountService2', 'UrlTenantHandlerService'];
